<template>
  <div>
    <Header />

    <Slider />

    <section class="card-section">
      <div class="container">
        <div class="card-sec-cont">
          <div class="title-div">
             <div class="m-2 top">
              <img src="@/assets/images/HOME/Grupo 1594@2x.png" alt="">
            </div>
            <h1>{{ $tc('home_page.div_title_h1') }}</h1>
          </div>
          <div class="mid-div">
            <div class="m-1">
              <div class="part">
                <div class="top-l">
                  <h2>{{ $tc('home_page.top_l_h2t') }}</h2>
                  <p>{{ $tc('home_page.top_l_p1t') }}</p>
                </div>
                <div class="top-r">
                  <img src="@/assets/images/HOME/Grupo 1597@2x.png" alt="">
                </div>
              </div>
              <div class="part">
                <div class="top-l">
                  <h2>{{ $tc('home_page.top_l_h2b') }}</h2>
                  <p>{{ $tc('home_page.top_l_p2b') }}</p>
                </div>
                <div class="top-r">
                  <img src="@/assets/images/HOME/Grupo 1596@2x.png" alt="">
                </div>
              </div>
            </div>

            <div class="m-2 dsp-none">
              <img src="@/assets/images/HOME/Grupo 1594@2x.png" alt="">
            </div>

            <div class="m-3">
              <div class="part2">
                <div class="top-r2">
                  <img src="@/assets/images/HOME/Grupo 1598@2x.png" alt="">
                </div>
                <div class="top-l2">
                  <h2>{{ $tc('home_page.top_l2_h2t') }}</h2>
                  <p>{{ $tc('home_page.top_l2_p1t') }}</p>
                </div>
              </div>
              <!--
              <div class="part2">
                <div class="top-r2">
                  <img src="@/assets/images/HOME/Grupo 1595@2x.png" alt="">
                </div>
                <div class="top-l2">
                  <h2>{{ $tc('home_page.top_l2_h2b') }}</h2>
                  <p>{{ $tc('home_page.top_l2_p1b') }}</p>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="calc">
      <div class="container">
        <div class="calc-cont">
          <div class="c-row">
            <div class="row-div rd-1">
              <h1>{{ $tc('home_page.calculator_sec_h1') }}
              </h1>
              <p>{{ $tc('home_page.calculator_sec_p') }}
              </p>
            </div>
            <div class="row-div">
              <div class="i-cont">
                <img src="@/assets/images/HOME/Grupo 1584@2x.png" alt="">
              </div>
            </div>
            <!--
            <div class="row-div">
              <div class="i-cont">
                <img src="@/assets/images/HOME/Grupo 1672@2x.png" alt="">
              </div>
            </div> -->
          </div>
          <div class="cards-row">
            <div class="card">
              <h3>{{ $tc('home_page.cards_card1_h3') }}</h3>
              <p>{{ $tc('home_page.cards_card1_p') }}
              </p>
            </div>
            <div class="card">
              <h3>{{ $tc('home_page.cards_card2_h3') }}</h3>
              <p>{{ $tc('home_page.cards_card2_p') }}
              </p>
            </div>
            <div class="card">
              <h3>{{ $tc('home_page.cards_card3_h3') }}</h3>
              <p>{{ $tc('home_page.cards_card3_p') }}
              </p>
            </div>
            <div class="card">
              <h3>{{ $tc('home_page.cards_card4_h3') }}</h3>
              <p>{{ $tc('home_page.cards_card4_p') }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <ContactBox />

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/Header'
import Slider from '@/components/layout/Slider'
import Footer from '@/components/layout/Footer'
import ContactBox from '@/components/ContactBox'

export default {
  name: 'Home',

  components: {
    Header,
    Slider,
    Footer,
    ContactBox
  },

  created () {
    document.title = process.env.VUE_APP_TITLE
  }
}
</script>
